import { NewMediaModule } from './new-media/new-media.module';
import { SiteCategoriesComponent } from './views/site-categories/site-categories.component';
import { NgModule } from "@angular/core";
import { Routes, RouterModule, Route } from "@angular/router";

import { PagesComponent } from "./views/pages/pages.component";
import { LoginComponent } from "./views/login/login.component";
import { LoginActivate, RoleGuard } from "./services/LoginActivate";
import { MainComponent } from "./views/main/main.component";
import { ReleaseManagerComponent } from "./views/release-manager/release-manager.component";
import { PageTemplatesComponent } from "./views/page-templates/page-templates.component";
import { MenusComponent } from "./views/menus/menus.component";
import { DashboardComponent } from "./views/dashboard/dashboard.component";
import { NewDahsboardComponent } from "./views/new-dahsboard/new-dahsboard.component";
import { AddEditPageComponent } from "./views/pages/add-edit-page/add-edit-page.component";
import { AddEditBlogComponent } from "./views/blogs-articles/add-edit-blog/add-edit-blog.component";
import { SiteThemesComponent } from "./views/site-themes/site-themes.component";
import { DataSourceComponent } from "./views/data-source/data-source.component";
import { AddEditDataSorceComponent } from "./views/data-source/AddEdit-data-sorce/AddEdit-data-sorce.component";
import { PermissionsComponent } from "./views/users-permissions/permissions/permissions.component";
import { RolesManagerComponent } from "./views/users-permissions/roles-manager/roles-manager.component";
import { AddEditRolesComponent } from "./views/users-permissions/permissions/add-edit-roles/add-edit-roles.component";
import { Error_403Component } from "./views/error_403/error_403.component";
import { ComponentPageComponent } from "./views/component-page/component-page.component";
import { ComponentsPrewiewComponent } from "./views/components-prewiew/components-prewiew.component";
import { EmailTemplateComponent } from "./views/email-template/email-template.component";
import { AddEditEmailTemplateComponent } from "./views/email-template/add-edit-email-template/add-edit-email-template.component";
import { NotificationsComponent } from "./views/notifications/notifications.component";
import { AddNotificationsComponent } from "./views/notifications/add-notifications/add-notifications.component";
import { SubmitFormsComponent } from "./views/submit-forms/submit-forms.component";
import { ViewBuilderComponent } from "./views/view-builder/view-builder.component";
import { SettingComponent } from "./views/view-builder/setting/setting.component";
import { SubmittedFormsComponent } from "./views/submitted-forms/submitted-forms.component";

import { CanDeactivateGuard } from "./blogs/can-deactivate.guard";
import { ActivityStatisticsComponent } from './activity-statistics/activity-statistics.component';
import { TranslationComponent } from './views/translation/translation.component';
import { WorkflowManagementComponent } from './workflow-management/workflow-management.component';
import { AddEditRestrictedWordComponent } from './views/restricted-words-management/add-edit-restricted-word/add-edit-restricted-word.component';
import { RestrictedWordsManagementComponent } from './views/restricted-words-management/restricted-words-management.component';
import { ComponentsTemplatesComponent } from './views/components-templates/components-templates.component';
import { LoggerComponent } from './views/logger/logger.component';
const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full"  as Route['pathMatch'] },
  {
    path: "",
    component: MainComponent,
    canActivate: [LoginActivate],
    children: [
      {
        path: "Dashboard",
        component: DashboardComponent,
        canActivate: [RoleGuard],
        data: { role: "DASH" },
      },

      {
        path: "new-dashboard",
        component: NewDahsboardComponent,
        canActivate: [RoleGuard],
        data: { role: "DASH" },
      },


      // {
      //   path:'wkflow-management',
      //   component:WorkflowManagementComponent ,
      //   canActivate: [RoleGuard],
      //   data: { role: "CATWF" },
      // } ,



      //   {
      //   path: "wkflow-management" ,
      //   loadChildren:()=>
      //   import("./workflow-management/workflow-management.module").then((mod) => mod.WorkflowManagementModule)
      // },



      {
        path: "page-templates",
        component: PageTemplatesComponent,
        canActivate: [RoleGuard],
        data: { role: "TMPL", minRoleCheck: true },
      },
      {
        path: "templates-builder/:id",
        component: ViewBuilderComponent,
        canActivate: [RoleGuard],
        data: { role: "TMPL" },
      },
      {
        path: "pages",
        component: PagesComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },
      {
        path: "pages/add",
        component: AddEditPageComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },
      {
        path: "pages/edit/:id",
        component: AddEditPageComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },
      {
        path: "pages/edit/:id/:duplicated",
        component: AddEditPageComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },

      {
        // path: "page-builder/:parentId/:id/:cultureId",
        path: "page-builder/:parentId/:id",
        component: ViewBuilderComponent,
        canActivate: [RoleGuard],

        data: { role: "PAGS" },
      },
      {
        path: "settings/:key/:token",
        component: SettingComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },
      // {
      //   path: "media-manager",
      //   component: MediaManagerComponent,
      //   canActivate: [RoleGuard],
      //   data: { role: "MEMGER" },
      // },
      {
        path: "release-manager",
        component: ReleaseManagerComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
      },
      {
        path: "site-categories",
        component: SiteCategoriesComponent,
        canActivate: [RoleGuard],
        data: { role: "PAGS" },
        //role: "CATSC"
      },

      {
        path: "blog",
        loadChildren: () =>
          import("./blogs/blogs.module").then((mod) => mod.BlogsModule),
      },

      {
        path: "restrict-word-manager", component: RestrictedWordsManagementComponent, canActivate: [RoleGuard], data: { role: "DASH" },
      },

      {
        path: "add-restrict-word", component: AddEditRestrictedWordComponent, canActivate: [RoleGuard], data: { role: "DASH" },
      },
      {
        path: "edit-restrict-word/:id", component: AddEditRestrictedWordComponent, canActivate: [RoleGuard], data: { role: "DASH" },
      },




      {
        path: "translation", component: TranslationComponent, canActivate: [RoleGuard], data: { role: "DASH" },
      },
        {
        path: "logger", component: LoggerComponent, canActivate: [RoleGuard], data: { role: "DASH" },
      },
      {
        path: "Blogs-Articles/add/:postCategoryId",
        component: AddEditBlogComponent,
        canActivate: [RoleGuard],
        data: { role: "BlgsArt" },
      },
      {
        path: "Blogs-Articles/edit/:id",
        component: AddEditBlogComponent,
        canActivate: [RoleGuard],
        data: { role: "BlgsArt" },
      },

      {
        path: "bg-settings",
        loadChildren: () =>
          import("./bg-services/bg-services.module")
            .then((mod) => mod.BgServicesModule),
      },

      /*   {
          path: "users-permissions/add-user",
          component: AddEditUserComponent,
          canActivate: [RoleGuard],
          data: { role: "USRS" },
        },
        {
          path: "users-permissions/edit-user/:id",
          component: AddEditUserComponent,
          canActivate: [RoleGuard],
          data: { role: "USRS" },
        }, */

      {
        path: "users-permissions/roles",
        component: PermissionsComponent,
        canActivate: [RoleGuard],
        data: { role: "RLE" },
      },
      {
        path: "users-permissions/roles-manager",
        component: RolesManagerComponent,
        canActivate: [RoleGuard],
        data: { role: "RLSMANGE" },
      },
      {
        path: "users-permissions/edit-role/:id",
        component: AddEditRolesComponent,
        canActivate: [RoleGuard],
        data: { role: "RLE" },
      },
      {
        path: "users-permissions/add-role",
        component: AddEditRolesComponent,
        canActivate: [RoleGuard],
        data: { role: "RLE" },
      },

      {
        path: "data-source",
        component: DataSourceComponent,
        canActivate: [RoleGuard],
        data: { role: "DTSRC" },
      },
      {
        path: "data-source/edit/:id",
        component: AddEditDataSorceComponent,
        canActivate: [RoleGuard],
        data: { role: "DTSRC" },
      },
      {
        path: "data-source/add",
        component: AddEditDataSorceComponent,
        canActivate: [RoleGuard],
        data: { role: "DTSRC" },
      },
      {
        path: "theme",
        component: SiteThemesComponent,
        canActivate: [RoleGuard],
        data: { role: "THEME" },
      },
      // {
      //   path: "menus",
      //   component: MenusComponent,
      //   canActivate: [RoleGuard],
      //   data: { role: "MENUS" },
      // },
      { path: "email-template", component: EmailTemplateComponent },
      { path: "email-template/add", component: AddEditEmailTemplateComponent },
      {
        path: "email-template/edit/:id",
        component: AddEditEmailTemplateComponent,
      },
      {
        path: "submit-forms",
        component: SubmitFormsComponent,
        canActivate: [RoleGuard],
        data: { role: "SUFRMS" },
      },


      {
        path: "survey",
        canActivate: [RoleGuard],
        data: { role: "SRVY" },
        loadChildren: () =>
          import("./survey/survey.module").then((mod) => mod.SurveyModule),
      },
      {
        path: "components",
        component: ComponentPageComponent,
      },
      {
        path: "components-templates",
        component: ComponentsTemplatesComponent,
      },
      { path: "Component-Preveiw/:id", component: ComponentsPrewiewComponent },
      {
        path: "catalog",
        data: { role: "CATP,CATC,CATO,CATPP", minRoleCheck: true },
        loadChildren: () =>
          import("./catalog/catalog.module").then((mod) => mod.CatalogModule),
      },
      {
        path: "system",
        loadChildren: () =>
          import("./countries-currencies/countries-currencies.module").then((mod) => mod.CountriesCurrenciesModule),
      },
      {
        path: "organizations",
        loadChildren: () =>
          import("./organization-management/organization-management.module").then((mod) => mod.OrganizationManagementModule),
      },
      /*  {
         path: "bgsettings",
         loadChildren: () =>
           import("./background-services-settings-management/background-services-settings.module").then((mod) => mod.BgServicesSettingsManagementModule),
       }, */
      // {
      //   path: "sites",
      //   loadChildren: () =>
      //     import("./sites-management/sites.module").then((mod) => mod.SitesModule),
      // },
      {
        path: "sites",
        loadChildren: () =>
          import("./new-sites-management/new-sites-management.module").then((mod) => mod.NewSitesManagementModule),
      },
      {
        path: "notification-manager",
        loadChildren: () =>
          import("./notification-manager/notification-manager.module").then((mod) => mod.NotificationManagerModule),
      },
      {
        path: "Ecommerce",
        loadChildren: () =>
          import("./e-commerce/ecommerce.module").then((mod) => mod.EcommerceModule),
      },

      {
        path: "email-settings",
        loadChildren: () =>
          import("./email-settings/email-settings.module").then((mod) => mod.EmailSettingsModule),
      },
      {
        path: "users-permissions/users",
        loadChildren: () =>
          import("./users-management/user-management.module").then((mod) => mod.UserManagementModule),
      },
      {
        path: "media",
        loadChildren: () =>
          import("./new-media/new-media.module").then((mod) => mod.NewMediaModule),
      },



      {
        path: "events-and-booking",
        loadChildren: () =>
          import("./events-calendar/events-calendar.module").then((mod) => mod.EventsCalendarModule),
      },

      {
        path: "graphic-profile",
        loadChildren: () =>
          import("./graphic-profile/graphic-profile.module").then((mod) => mod.GraphicProfileModule),
      },
      {
        path: "site-menus",
        loadChildren: () =>
          import("./site-menu/site-menu.module").then((mod) => mod.SiteMenuModule)
      },
      {
        path: "error-logs",
        loadChildren: () =>
          import('./error-logs/error-logs.module').then((mod) => mod.ErrorLogsModule)
      },
      {
        path: "new-blogs",
        loadChildren: () =>
          import("./new-blogs/new-blogs.module").then((mod) => mod.NewBlogsModule),
      },
      {
        path: "domains",
        loadChildren: () =>
          import("./domains/domains.module").then((mod) => mod.DomainsModule)
      },


      {
        path: "statistics",
        loadChildren: () =>
          import("./statistics/statistics.module").then((mod) => mod.StatisticsModule),
      },
      {
        path: "dynamic-forms",
        loadChildren: () =>
          import("./dynamic-forms/dynamic-forms.module").then((mod) => mod.DynamicFormsModule),
      },

      {
        path: "customer-portal",
        loadChildren: () =>
          import("./CP/form-builder/form-builder.module").then((mod) => mod.FormBuilderModule),
      },


      
      {
        path: "rule-builder",
        loadChildren: () =>
          import("./CP/rule-builder/rule-builder.module").then((mod) => mod.RuleBuilderModule),
      },

    {
        path: "integration",
        loadChildren: () =>
          import("./CP/integration/integration.module").then((mod) => mod.IntegrationModule),
      },
         {
        path: "payment",
        loadChildren: () =>
          import("./CP/payment/payment.module").then((mod) => mod.PaymentModule),
      },
      {
        path: "workflow-management",
        loadChildren: () => import("./workflow-management/workflow-management.module").then((mod) => mod.WorkflowManagementModule)
      },









      { path: "notifications", component: NotificationsComponent },
      { path: "notifications/:id", component: AddNotificationsComponent },
      { path: "submitted-forms", component: SubmittedFormsComponent },

      { path: "404", component: Error_403Component },
    ],
  },
  // { path: 'forgot-password', component: ForgotPasswordComponent },

  // { path: 'reset-password/:userId/:code', component: ResetPasswordComponent },









  { path: "login", component: LoginComponent },
  { path: "activity", component: ActivityStatisticsComponent },
  { path: "forgot-password", component: LoginComponent },
  { path: "reset-password/:userId/:code", component: LoginComponent },

  { path: "**", redirectTo: "login" },
  { path: 'graphic-profile', loadChildren: () => import('./graphic-profile/graphic-profile.module').then(m => m.GraphicProfileModule) },

];

@NgModule({

  imports: [
    // RouterModule.forRoot(routes, {
    //   useHash: false,
    //   onSameUrlNavigation: "reload",
    // }),
    RouterModule.forRoot(routes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
      canceledNavigationResolution: 'computed',
      paramsInheritanceStrategy: 'always',
      urlUpdateStrategy: 'eager',

    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
export { RouterModule };

